import { IWidget } from '../widgets';

export class Page {
    widgets: IWidget[];

    constructor() { this.widgets = []; }
}